import { CardType } from '@generated-types';
import useQueryParam from '@hooks/use-query-param';

const isCardType = (value: string): value is CardType => value === CardType.CREDIT || value === CardType.DEBIT;

export const useCardType = (): CardType | undefined => {
    const type = useQueryParam('ctype');

    if (typeof type !== 'string' || type.length === 0 || !isCardType(type)) {
        return undefined;
    }

    return type;
};
